import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../lib/api';
import { initAnalytics } from '../lib/analytics';

// Fetches the admin-configured SEO globals (GA4 Measurement ID, Search Console
// verification) once and applies them site-wide. Public, unauthenticated
// endpoint — these values are meant to live in page source anyway.
export default function GlobalSeoConfig() {
  const { data, isSuccess, isError } = useQuery({
    queryKey: ['public', 'seo-settings'],
    queryFn: () => apiRequest('/api/settings/seo'),
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  useEffect(() => {
    // Wait for the fetch to settle either way — on error we still fall back to
    // the build-time env var rather than never initialising analytics.
    if (!isSuccess && !isError) return;
    initAnalytics(data?.ga4_measurement_id);
    if (!data) return;

    if (data.search_console_verification) {
      let tag = document.head.querySelector('meta[name="google-site-verification"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'google-site-verification');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', data.search_console_verification);
    }
  }, [data, isSuccess, isError]);

  return null;
}
